import { bool, node, string } from 'prop-types'

import Button from 'views/components/atoms/Button'
import TextWithIcon from 'views/components/molecules/TextWithIcon'

const ButtonWithIconText = props => {
  const { icon, children, right, position, ...rest } = props

  if (position === 'top') {
    return (
      <Button {...rest}>
        <div className="u-padding-large--ends u-padding-x-small--sides">
          <div className="u-margin-small--bottom">{icon}</div>
          <div>{children}</div>
        </div>
      </Button>
    )
  }

  return (
    <Button {...rest}>
      <TextWithIcon icon={icon} right={right}>
        {children}
      </TextWithIcon>
    </Button>
  )
}

ButtonWithIconText.propTypes = {
  ...Button.propTypes,
  icon: node.isRequired,
  right: bool,
  position: string,
}

ButtonWithIconText.defaultProps = {
  ...Button.defaultProps,
  right: false,
  position: '',
}

export default ButtonWithIconText
